import { defineMessages } from 'react-intl'

export default defineMessages({
  urlNote: {
    id: 'Slate.HoverMenu.UrlNote',
    defaultMessage: 'Please provide a valid URL.'
  }
})
